import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Settings } from '../../../assets/settings.svg';
import { ReactComponent as ImportIcon } from '../../../assets/import.svg';
import { ReactComponent as Users } from '../../../assets/users.svg';
import UseGetUserRole from '../../../components/useGetUserRole';
import { capitalizeFirstLetterofEachWord } from '../../../globalUtils/capitalizeFirstLetterofEachWord';
import { baseURL } from '../../../globalUtils/axiosConfig';

const typesArray = ['Teacher', 'Admin'];
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

const useSidebar = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [data, setData] = useState();
  const [isSuperAdmin] = UseGetUserRole();
  const [showSettings, setShowSettings] = useState(true);

  useEffect(() => {
    setData(user);

    if (user?.role === 'Admin') {
      setShowSettings(false);
    }
  }, [user]);

  const handleRoleLength = (role) =>
    role.length > 20 ? `${role.substring(0, 18) + ' ...'}` : role;

  const handleNameLength = (role) =>
    role.length > 15 ? role.substring(0, 15) + '...' : role;

  const getRole = () => {
    const { role } = data;

    if (typesArray.includes(role)) {
      return capitalizeFirstLetterofEachWord(role);
    } else {
      return handleRoleLength(data?.job_title || '');
    }
  };

  let name = handleNameLength(data?.first_name + ' ' + data?.last_name || '');

  const menuItemsData = [
    {
      key: '1',
      src:
        data?.profile_picture?.length > 1
          ? `${baseURL}/uploads/${data?.profile_picture}`
          : null,
      SvgImg: false,
      alt: '',
      name: data ? name : '',
      role: `Timezone: ${timeZone}`,
      link: '/profile',
      hasSubItems: false,
      permission: true,
      hasPermission: true,
    },
    {
      key: '3',
      SvgImg: ImportIcon,
      alt: 'Institute Management',
      name: 'Institute Management',
      link: '/institute-management',
      hasSubItems: false,
      hasPermission: user?.roles?.includes('super_admin'),
    },
    {
      key: '2',
      SvgImg: Users,
      alt: 'User Management',
      name: 'User Management',
      link: '/users-manager',
      hasSubItems: false,
      hasPermission: user?.roles?.includes('super_admin'),
    },
    {
      key: '4',
      SvgImg: Settings,
      alt: 'Push Notifications',
      name: 'Push Notifications',
      link: '/push-notifications',
      hasSubItems: false,
      hasPermission: user?.roles?.includes('super_admin'),
    },
  ];

  return [menuItemsData];
};

export default useSidebar;
